
const Referans = resolve => {
    require.ensure(['../views/apps/referans/Referans'], () => {
        resolve(require('../views/apps/referans/Referans'))
    })
};
const ReferansTanimlama = resolve => {
    require.ensure(['../views/apps/referans/ReferansTanimla'], () => {
        resolve(require('../views/apps/referans/ReferansTanimla'))
    })
};
const ReferansListe = resolve => {
    require.ensure(['../views/apps/referans/ReferansListe'], () => {
        resolve(require('../views/apps/referans/ReferansListe'))
    })
};

const ReferansDuzenle = resolve => {
    require.ensure(['../views/apps/referans/ReferansDuzenle'], () => {
        resolve(require('../views/apps/referans/ReferansDuzenle'))
    })
};

import layouts from '../layout'

export default {
    path: '/referans',
    name: 'referans',
    component: Referans,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [
        {
            path: 'tanimlama',
            name: 'referanstanimlama',
            component: ReferansTanimlama,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: 'liste',
            name: 'referansliste',
            component: ReferansListe,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
        {
            path: 'guncelleme',
            name: 'referansguncelle',
            component: ReferansDuzenle,
            meta: {
                auth: true,
                layout: layouts.navLeft,
                searchable: true,
                tags: ['app']
            }
        },
    ]
}
